import { forwardRef } from "react";

const stats = [
  { value: "+450.000", label: "Registos geridos atualmente em diversas instituições" },
  { value: "15+", label: "Anos de evolução tecnológica contínua" },
  { value: "100%", label: "Multi-plataforma — estabilidade garantida pela robustez da tecnologia Java" },
];

const SocialProof = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section ref={ref} className="py-24 bg-foreground text-background">
      <div className="container mx-auto px-4 max-w-5xl">
        <p className="text-background/50 font-semibold text-xs uppercase tracking-[0.2em] text-center mb-3">Experiência comprovada</p>
        <h2 className="text-3xl md:text-4xl font-bold text-background text-center mb-16 font-serif">
          Confiança construída ao longo de décadas.
        </h2>

        <div className="grid md:grid-cols-3 gap-px bg-background/10">
          {stats.map((s, i) => (
            <div key={i} className="text-center bg-foreground p-10">
              <div className="text-4xl md:text-5xl font-bold text-background font-serif mb-3 animate-count-up">
                {s.value}
              </div>
              <p className="text-background/60 leading-relaxed text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

SocialProof.displayName = "SocialProof";

export default SocialProof;
